import { render, staticRenderFns } from "./FullOffer.vue?vue&type=template&id=796be5d2&scoped=true"
import script from "./FullOffer.vue?vue&type=script&lang=js"
export * from "./FullOffer.vue?vue&type=script&lang=js"
import style0 from "./FullOffer.vue?vue&type=style&index=0&id=796be5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796be5d2",
  null
  
)

export default component.exports